module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1954"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1999"
  }, [_c('a', {
    attrs: {
      "href": "#/html/04_Preface#page_ix"
    }
  }, [_vm._v("Preface and Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_CHAPTER#page_1"
    }
  }, [_vm._v("CHAPTER")])]), _c('a', {
    attrs: {
      "href": "#/html/05_CHAPTER#page_1"
    }
  }, [_vm._v("1. What Is Quality of Government?")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/06_CHAPTER#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/06_CHAPTER#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Quality of Government: What You Get")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_CHAPTER#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/07_CHAPTER#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Corruption: The Killing Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Creating Political Legitimacy: Representative Democracy versus Quality of Government")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Curbing Corruption: The Indirect “Big Bang” Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Quality of Government and the Welfare State")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Low Trust–Corruption–Inequality Trap")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Quality of Government and Social Trust: Two Experiments")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Tale of Two Countries: Democratic Jamaica versus High Quality of Government Singapore")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER")])]), _c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Preventing Societies from Self-Destructing")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14a_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Referenc#page_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C2003"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Index#page_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df0182e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_Contents.vue
// module id = 66
// module chunks = 0